<ng-container *ngIf="(isPublicRoute$ | async) === false; else publicArea">
  <div class="layout">
    <app-header (toggleSidebar)="onToggleSidebar()"></app-header>
    <app-alert></app-alert>
    <div class="shell" [class.hidden]="isSidebarHidden">
      <app-sidebar></app-sidebar>
      <main class="content">
        <app-loader></app-loader>
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</ng-container>

<ng-template #publicArea>
  <app-alert></app-alert>
  <div class="public-content">
    <app-loader></app-loader>
    <router-outlet></router-outlet>
  </div>
</ng-template>
